'use client';

import React, { memo, useCallback } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Pagination } from 'antd';

const BlogPagination = ({ total }: { total: number }) => {
	const searchParams = useSearchParams();
	const pathname = usePathname();
	const { push } = useRouter();

	const page = searchParams.get('page') || 1;

	const handleChangePagination = useCallback(
		(newPage: any) => {
			const params = new URLSearchParams(searchParams);
			params.set('page', newPage);
			push(`${pathname}?${params.toString()}`);
		},
		[pathname]
	);

	return (
		<div className={'mt-10'}>
			<Pagination
				defaultCurrent={1}
				current={Number(page)}
				pageSize={10}
				onChange={handleChangePagination}
				total={total}
			/>
		</div>
	);
};

export default memo(BlogPagination);
